import { useCallback } from "react";
import { acceptCrewInvite } from "@/api/client";
import { useAuthStore } from "@/stores/auth";
import { AcceptInviteFlow } from "@/components/AcceptInviteFlow";

export function AcceptCrewInvitePage() {
  const initialize = useAuthStore((s) => s.initialize);

  const handleSuccess = useCallback((_data: unknown) => {
    // Refresh auth context so downstream pages see the new crew membership.
    initialize();
  }, [initialize]);

  const handleError = useCallback(async () => {
    // No user-level "has_crew_profile" flag exists yet — treat errors as real errors.
    return false;
  }, []);

  return (
    <AcceptInviteFlow
      returnPath="/accept-crew-invite"
      title="Accept crew invite"
      subtitle="Sign in or create an account to join the crew."
      acceptFn={acceptCrewInvite}
      onSuccess={handleSuccess}
      onError={handleError}
      successMessage="You've been added to the crew. Your shifts are ready."
      successLink="/my-shifts"
      successLabel="View My Shifts"
    />
  );
}
